import { useEffect, useState } from "react";
import { useAppContext } from "../../libs/app-core/AppContext";
import { OnApiError } from "../ErrorManager";
import { UniForm } from "./UniForm";
import { DAO } from "./DAO";
import { UniQuestion } from "./UniQuestion";
import { UniOption } from "./UniOption";
import { UniInput } from "./UniInput";
import { UniFunc } from "./UniFunc";
import { API, ApiResult } from "./API";
import { WS } from "./WS";

export class UniFormDAO {

  /** 
   * 產生問卷的立體樹狀結構:  
   * - 輸入事先準備好所有版本的定義檔  
   * - 一次將對應的物件倆倆綁定
  */
  static FillFormTree(cache_forms: UniForm[], cache_questions: UniQuestion[], cache_options: UniOption[], cache_inputs: UniInput[]) {

    // 資料來源如下:
    // const cache_forms = await UniFormDAO.Select對應版本的Forms(form_guid_list);
    // const cache_questions = await UniQuestionDAO.Select_對應版本的Questions(form_guid_list);
    // const cache_options = await UniOptionDAO.Select_對應版本的Options(form_guid_list); 
    // const cache_inputs = await UniInputDAO.Select_對應版本的Inputs(form_guid_list); 

    for (const form of cache_forms) {
      form.AllQuestions = cache_questions.filter((x) => x.form_guid === form.guid);// 對所有的 form 取的所屬的 questions
      form.AllOptions = cache_options.filter((x) => x.form_guid === form.guid);// 對所有的 form 取的所屬的 options
      form.AllInputs = cache_inputs.filter((x) => x.form_guid === form.guid);// 對所有的 form 取的所屬的 options

      for (const question of form.AllQuestions) {
        question.OwnerForm = form;// 填入所屬的 form

        // 填入屬於此題的選項
        question.Options = form.AllOptions.filter((x) => x.question_guid === question.guid);

        // 對所有選項，指定所屬的題目
        for (const opt of question.Options) {
          opt.OwnerQuestion = question;

          opt.Inputs = cache_inputs.filter((x) => x.option_guid === opt.guid);

          // 對所有Inputs，指定所屬的選項
          for (const input of opt.Inputs) {
            input.OwnerOption = opt;
          }

        }
      }
    }
  }



  static async Insert_空白問卷版本(uni_func: UniFunc): Promise<UniForm> {
    var data = new UniForm();

    data.func_guid = uni_func.guid;

    // 記憶所屬問卷
    data.form_code = uni_func.func_code;
    data.form_title = uni_func.func_title;

    let refetch_data = await DAO.Insert(UniForm, data);
    return refetch_data;
  }

  static async FetchByGuid(guid: string): Promise<UniForm> {
    let data = await DAO.FetchByGuid(UniForm, guid);
    return data;
  }

  static async Select(func_guid: string | null | undefined): Promise<UniForm[]> {
    let cond = " WHERE (1=1) "
      + " AND " + Cnd.指定所屬主檔(func_guid)
      + Cnd.OrderBy預設排序();

    let data_list = await DAO.Select(UniForm, cond);
    return data_list;
  }

  static async WS_SelectForms_ByFormGuidList(form_guid_list: string[] | null | undefined): Promise<UniForm[]> {
    let api_rslt: ApiResult = await WS.CallWS(
      "uni_form/select_by_form_guid_list",
      { form_guid_list: form_guid_list }
    );

    if (api_rslt.code === API.CODE_OK) {
      return API.ToClassList(UniForm, api_rslt.data);
    } else {
      throw new Error(`API Error: ${api_rslt.code} ${api_rslt.message} !!!`);
    }
  }

  static async Select_最新的一般問卷(): Promise<UniForm[]> {
    let cond = " WHERE (1=1) "
      + " AND " + Cnd.指定一般問卷()
      + " AND " + Cnd.指定最新版本()

    let data_list = await DAO.Select(UniForm, cond);
    return data_list;
  }

}

class Cnd {

  static 指定所屬主檔(func_guid: string | null | undefined) {
    if (func_guid == null) {
      return " (1=0) ";
    } else {
      return ` (func_guid='${func_guid}') `;
    }
  }

  static 指定一般問卷() {
    return ` (is_spwk = 0) `;
  }


  static 指定最新版本() {
    return ` (is_curr='1') `;
  }

  static OrderBy預設排序() {
    return ` ORDER BY is_curr DESC, ver DESC, serno DESC `;
  }
}


export function useUniForm(guid: string) {
  const ctx = useAppContext();

  const [_UniForm, set_UniForm] = useState<UniForm | null>(null);

  async function refresh_UniForm() {
    try {
      const data_list = await UniFormDAO.FetchByGuid(guid);
      set_UniForm(data_list);
    } catch (ex: any) {
      OnApiError(ctx, ex);
      return;
    }
  };

  useEffect(() => {
    refresh_UniForm();
  }, [guid]);

  return { _UniForm, set_UniForm, refresh_UniForm }
}


export function useUniFormList(func_guid: string | null | undefined) {
  const ctx = useAppContext();

  const [_UniFormList, set_UniFormList] = useState<UniForm[]>([]);

  async function refresh_UniFormList() {
    try {
      const data_list = await UniFormDAO.Select(func_guid);
      set_UniFormList(data_list);
    } catch (ex: any) {
      OnApiError(ctx, ex);
      return;
    }
  };

  useEffect(() => {
    refresh_UniFormList();
  }, [func_guid]);

  return { _UniFormList, set_UniFormList, refresh_UniFormList }
}